import React from 'react';
import Layout from '../../../components/layout';
import Headline from '../../../components/headline';
import MetaData from '../../../components/meta-data';
import Breadcrumbs from '../../../components/breadcrumbs';
var TravelIndex = function TravelIndex(props) {
    var _props$data$seo$edges, _props$data$seo$edges2, _props$data$seo$edges3, _props$data$montana$e, _props$data$pacificNo, _props$data$napa$edge, _props$data$santaFe$e;
    return /*#__PURE__*/ React.createElement(Layout, null, /*#__PURE__*/ React.createElement(MetaData, {
        title: "Travel Photos",
        description: "Some photos that I've taken while traveling.  My hopes is that this gallery fills up quicker than the rest.",
        photos: {
            full: (_props$data$seo$edges = props.data.seo.edges[0].node.full) === null || _props$data$seo$edges === void 0 ? void 0 : _props$data$seo$edges.fixed,
            facebook: (_props$data$seo$edges2 = props.data.seo.edges[0].node.facebook) === null || _props$data$seo$edges2 === void 0 ? void 0 : _props$data$seo$edges2.fixed,
            twitter: (_props$data$seo$edges3 = props.data.seo.edges[0].node.twitter) === null || _props$data$seo$edges3 === void 0 ? void 0 : _props$data$seo$edges3.fixed
        }
    }), /*#__PURE__*/ React.createElement(Breadcrumbs, {
        path: props
    }), /*#__PURE__*/ React.createElement("div", {
        className: "grid"
    }, /*#__PURE__*/ React.createElement("section", {
        className: "copy "
    }, /*#__PURE__*/ React.createElement("h1", null, "Travels"), /*#__PURE__*/ React.createElement("p", null, "Here's some shots from some random trips I've been on throughout the years. Currently my favorite place to visit is Big Sky Montana, probably why my wife and I ended up getting married there. The photo set I have from there is one of my favorites as well. It's a mix of summer and winter, both equally awesome times to visit."))), /*#__PURE__*/ React.createElement(Headline, {
        imagePlacement: 'left',
        image: {
            source: (_props$data$montana$e = props.data.montana.edges[Math.floor(Math.random() * props.data.montana.edges.length)].node.childImageSharp) === null || _props$data$montana$e === void 0 ? void 0 : _props$data$montana$e.fluid,
            altText: 'Any'
        },
        link: '/photos/travel/montana/',
        copy: {
            headline: {
                h1: 'Montana'
            },
            text: 'Summer and winter journies throughout the years in Montana.  Some Yellowstone National Park photos and some shots taking during our time in Big Sky and Bozeman'
        }
    }), /*#__PURE__*/ React.createElement(Headline, {
        imagePlacement: 'right',
        image: {
            source: (_props$data$pacificNo = props.data.pacificNorthwest.edges[Math.floor(Math.random() * props.data.pacificNorthwest.edges.length)].node.childImageSharp) === null || _props$data$pacificNo === void 0 ? void 0 : _props$data$pacificNo.fluid,
            altText: 'Any'
        },
        link: '/photos/travel/pacific-northwest/',
        copy: {
            headline: {
                h1: 'Pacific Northwest',
                spanLinksTo: '/photos/travel/'
            },
            text: "Journies through Seattle, Portland, Vancouver and Whistler. It was our first time to the Pacific Northwest and we can't wait to go back"
        }
    }), /*#__PURE__*/ React.createElement(Headline, {
        imagePlacement: 'left',
        image: {
            source: (_props$data$napa$edge = props.data.napa.edges[Math.floor(Math.random() * props.data.napa.edges.length)].node.childImageSharp) === null || _props$data$napa$edge === void 0 ? void 0 : _props$data$napa$edge.fluid,
            altText: 'Any'
        },
        link: '/photos/travel/napa/',
        copy: {
            headline: {
                h1: 'Napa California'
            },
            text: 'Tour through Napa with some stops at The French Laundry, Reguchi, Whetstone, Reverie and some other great spots'
        }
    }), /*#__PURE__*/ React.createElement(Headline, {
        imagePlacement: 'right',
        image: {
            source: (_props$data$santaFe$e = props.data.santaFe.edges[Math.floor(Math.random() * props.data.santaFe.edges.length)].node.childImageSharp) === null || _props$data$santaFe$e === void 0 ? void 0 : _props$data$santaFe$e.fluid,
            altText: 'Any'
        },
        link: '/photos/travel/santa-fe/',
        copy: {
            headline: {
                h1: 'Santa Fe'
            },
            text: "Went out to Santa Fe to celebrate my Mom's birthday.  Had a lot of fun and turns our I uncovered some sort of door obsession."
        }
    }));
};
export default TravelIndex;
var query = "2436414653";
